import {Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
// import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import {LoginPage} from '../../almamotor/pages/login/LoginPage'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<LoginPage />} />
      <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route index element={<LoginPage />} />
    </Route>
  </Routes>
)

export {AuthPage}
